<div class="row">
  <div class="col">
    <span class="message-text">{{ message }}</span>
  </div>
</div>